import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RoutePlannerFormComponent } from '../../route-planner-form.component';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationService } from 'src/app/modules/route-planner/services/location/location.service';
import { MapService } from 'src/app/modules/route-planner/services/map/map.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { LineAutoCompleteComponent } from './line-auto-complete/line-auto-complete.component';
import { Route } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/route.interface';
import { FormValidators } from 'src/app/@forms/validators/validators';
import { FavoriteLine } from 'src/app/modules/route-planner/interfaces/favorites/favorite-line.interface';
import {
  map,
  Observable,
  of,
  ReplaySubject,
  Subject,
  switchMap,
  tap,
  combineLatest,
  startWith,
  debounceTime,
  take,
} from 'rxjs';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';
import { SearchLineForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/search-line-form';
import { RouteStops } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { SearchLineResultsContainerComponent } from 'src/app/modules/route-planner/containers/route-planning/route-planning-results-container/search-line-results-container/search-line-results-container.component';
import { AutoCompleteService } from 'src/app/modules/route-planner/services/auto-complete/auto-complete.service';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  BOARDING_STATION,
  DIRECTION,
  DROP_OFF_STATION,
  LINE_ALTERNATIVES_ORDER,
  LINE_NUMBER_AND_CITY,
  LINE_SEARCHING,
  SEARCH_LINE,
  STATION_CODE,
  PLATFORM,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { PlannerSurveyOrchestratorService } from 'src/app/modules/route-planner/services/survey/planner-survey-orchestrator.service';

@Component({
    selector: 'app-search-line-form',
    templateUrl: './search-line-form.component.html',
    styleUrls: ['./search-line-form.component.scss'],
    standalone: false
})
export class SearchLineFormComponent
  extends RoutePlannerFormComponent
  implements OnInit {

  private readonly initialSearchLineFormValues = {
    line: null,
    direction: { value: null, disabled: true },
    boardingStation: { value: null, disabled: true },
    dropingStation: { value: null, disabled: true },
  };


  @Output() toggleSearchButton: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() toogleLoader: EventEmitter<boolean> = new EventEmitter<boolean>();

  fetchedRouteData$ = new ReplaySubject<RouteStops>();

  directionsOpts$: Observable<SelectOption<RouteStops>[]>;
  stops$: Observable<SelectOption<Stop>[]>;
  boardingStops$: Observable<SelectOption<Stop>[]> = of([]);
  dropingStops$: Observable<SelectOption<Stop>[]> = of([]);
  filteredBoardingStops$: Observable<SelectOption<Stop>[]>;
  filteredDropingStops$: Observable<SelectOption<Stop>[]>;
  private boardingStationFilterText = new Subject<string>();
  private dropingStationFilterText = new Subject<string>();

  lineNumberAndCityText: string;
  lineSearchingText: string;
  directionText: string;
  boardingStationText: string;
  dropOffStationText: string;
  lineAlternativesOrderText: string;
  stationCodeText: string;
  platformText: string;

  isLineActive: boolean

  direction: Direction;

  isRouteHasAlternatives: boolean = false
  isPickedFromFavorite: boolean = false


  private isSubmittingForm = false;
  private isAutofilling = false;

  constructor(
    fb: FormBuilder,
    locationsService: LocationService,
    queryParamsService: QueryParamsService,
    routePlanningService: RoutePlanningService,
    router: Router,
    utilService: UtilsService,

    private readonly scheduleService: ScheduleService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly languageService: LanguageService,
    private readonly modalService: ModalService,
    private readonly plannerSurveyOrchestrator: PlannerSurveyOrchestratorService
  ) {
    super(
      eTab.LINES,
      'חפש קו',
      fb,
      locationsService,
      queryParamsService,
      routePlanningService,
      router,
      utilService
    );

    this.routePlannerForm = fb.group({
      ...this.routePlannerForm.controls,
      line: new FormControl<RouteStops>(this.initialSearchLineFormValues.line, [FormValidators.required]),
      direction: new FormControl<RouteStops>(this.initialSearchLineFormValues.direction, [
        FormValidators.required,
      ]),
      boardingStation: new FormControl<Stop>(this.initialSearchLineFormValues.boardingStation, [
        FormValidators.required,
      ]),
      dropingStation: new FormControl<Stop>(this.initialSearchLineFormValues.dropingStation, [
        FormValidators.required,
      ]),
    });

  }

  ngOnInit(): void {
    this.afterRouteStopsFetched(
      this.routePlannerForm.controls['line'].valueChanges.pipe(
        tap((line: RouteStops | null) => {
          if (line) {
            this.toogleLoader.emit(true)
            const queryParams: any = {
              routeId: line.routeId,
            };

            // Only add oppositeRouteId if it exists
            if (line.oppositeDirectionId) {
              queryParams.oppositeRouteId = line.oppositeDirectionId;
            }

            this.queryParamsService.setQueryParams(queryParams);
          }
        }),
        tap((line: RouteStops | null) => {
          if (!!line) {
            this.routePlannerForm.patchValue({
              boardingStation: null,
              dropingStation: null,
            });
          }
        }),
        switchMap((line: RouteStops | null) => {
          if (line) {
            return this.scheduleService.getRouteStops(
              line.routeId,
              line.oppositeDirectionId
            );
          }
          return of(null);
        })
      ),
      true
    ).subscribe((data) => {
      //  if(!data?.data.route) {
      //   this.isLineActive = false
      // } else {
      //   this.isLineActive = true
      // }
      if (this.isPickedFromFavorite) {
        this.submitRoutePlannerForm()
      } else {
        const lineValue = this.routePlannerForm.controls['line'].value;
        if (lineValue && lineValue.routeId) {
          this.scheduleService.checkIfRouteHasAlternatives(lineValue.routeId).subscribe({
            next: (res) => {
              this.isRouteHasAlternatives = res.data
              this.toogleLoader.emit(false)
            },
            error: (err) => {
              this.toogleLoader.emit(false)
            }
          })
        } else {
          this.toogleLoader.emit(false)
        }
      }

    });

    this.routePlannerForm.controls['direction'].valueChanges.subscribe(
      (selectedRoute: RouteStops) => {
        const route: RouteStops = this.routePlannerForm.controls['line'].value;

        if (!!selectedRoute && !!route) {
          this.queryParamsService.setQueryParams({
            boardingStation: null,
            dropingStation: null,
          });

          if (selectedRoute.routeId != route.routeId) {
            this.routePlannerForm.patchValue({ line: selectedRoute });
            this.setDirectionsOptions(selectedRoute, route);
            this.setStopsOptions(selectedRoute);
          }
        }
      }
    );

    this.routePlannerForm.controls['boardingStation'].valueChanges.subscribe(
      (boardingStop: Stop) => {
        if (!!boardingStop) {
          this.dropingStops$ = this.stops$.pipe(
            map((stops) =>
              stops.filter(
                (stop) =>
                  stop.value.stopSequence > boardingStop.stopSequence &&
                  stop.value.stopSequence != 0 && !stop.value.isDropoff
              )
            )
          );
          // Reinitialize filtered droping stops when dropingStops$ changes
          this.initializeDropingStationFiltering();
          this.queryParamsService.setQueryParam(
            'boardingStation',
            boardingStop.stopcode
          );
        }
      }
    );

    this.routePlannerForm.controls['dropingStation'].valueChanges.subscribe(
      (dropingStop: Stop) => {
        if (!!dropingStop) {
          this.boardingStops$ = this.stops$.pipe(
            map((stops) =>
              stops.filter(
                (stop) =>
                  stop.value.stopSequence < dropingStop.stopSequence &&
                  stop.value.stopSequence != 0 && !stop.value.isPickup
              )
            )
          );
          // Reinitialize filtered boarding stops when boardingStops$ changes
          this.initializeBoardingStationFiltering();
          this.queryParamsService.setQueryParam(
            'dropingStation',
            dropingStop.stopcode
          );
        }
      }
    );
    this.initializeMultiLanguageTexts();
    this.initializeStationFiltering();
  }

  private initializeStationFiltering() {
    this.initializeBoardingStationFiltering();
    this.initializeDropingStationFiltering();
  }

  private initializeBoardingStationFiltering() {
    // Initialize filtered boarding stops - use startWith to ensure it emits initial value
    this.filteredBoardingStops$ = combineLatest([
      this.boardingStops$.pipe(startWith([])),
      this.boardingStationFilterText.pipe(
        startWith(''),
        debounceTime(100)
      )
    ]).pipe(
      map(([options, filterText]: [SelectOption<Stop>[], string]) => {
        if (!filterText || filterText.trim() === '') {
          return options;
        }
        
        const searchText = this.removeSpecialCharacters(filterText.toLowerCase().trim());
        const language = this.languageService.getSelectedLanguage();
        return options.filter(option => 
          this.removeSpecialCharacters(option.value.name[language.symbol]?.toLowerCase() || '').includes(searchText) ||
          this.removeSpecialCharacters(option.value.name.he?.toLowerCase() || '').includes(searchText) ||
          option.value.stopcode?.toString().includes(searchText)
        );
      })
    );
  }

  private initializeDropingStationFiltering() {
    // Initialize filtered droping stops - use startWith to ensure it emits initial value
    this.filteredDropingStops$ = combineLatest([
      this.dropingStops$.pipe(startWith([])),
      this.dropingStationFilterText.pipe(
        startWith(''),
        debounceTime(100)
      )
    ]).pipe(
      map(([options, filterText]: [SelectOption<Stop>[], string]) => {
        if (!filterText || filterText.trim() === '') {
          return options;
        }
        const searchText = this.removeSpecialCharacters(filterText.toLowerCase().trim());
        const language = this.languageService.getSelectedLanguage();
        return options.filter(option => 
          this.removeSpecialCharacters(option.value.name[language.symbol]?.toLowerCase() || '').includes(searchText) ||
          this.removeSpecialCharacters(option.value.name.he?.toLowerCase() || '').includes(searchText) ||
          option.value.stopcode?.toString().includes(searchText)
        );
      })
    );
  }

  private removeSpecialCharacters(text: string): string {
    return text.replace(/[^a-zA-Z0-9\u0590-\u05FF\u0600-\u06FF\s]/g, '');
  }

  onBoardingStationTextChange(text: string) {
    this.boardingStationFilterText.next(text);
  }

  onBoardingStationSelected(stop: Stop) {
    this.boardingStationFilterText.next('');
  }

  onDropingStationTextChange(text: string) {
    this.dropingStationFilterText.next(text);
  }

  onDropingStationSelected(stop: Stop) {
    this.dropingStationFilterText.next('');
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.lineNumberAndCityText = LINE_NUMBER_AND_CITY[language.language];
      this.lineSearchingText = LINE_SEARCHING[language.language];
      this.directionText = DIRECTION[language.language];
      this.boardingStationText = BOARDING_STATION[language.language];
      this.dropOffStationText = DROP_OFF_STATION[language.language];
      this.lineAlternativesOrderText =
        LINE_ALTERNATIVES_ORDER[language.language];
      this.stationCodeText = STATION_CODE[language.language];
      this.platformText = PLATFORM[language.language];
      this.buttonTitle = SEARCH_LINE[language.language];
    });
  }

  private afterRouteStopsFetched(
    routeStops$: Observable<
      ServiceResponse<{
        route: RouteStops;
        oppositeDirectionRoute: RouteStops;
      } | null>
    >,
    initalizeCtrls?: boolean
  ) {
    return routeStops$.pipe(
      tap(
        (
          lineFullData: ServiceResponse<{
            route: RouteStops;
            oppositeDirectionRoute: RouteStops;
          } | null>
        ) => {
          if (!!lineFullData?.data) {
            const { route, oppositeDirectionRoute: oppositeRoute } =
              lineFullData.data;
            if (route) {
              this.setFormOptions(route, oppositeRoute, initalizeCtrls);
            }
          }
        }
      ),
      tap((lineFullData) => {
        Object.keys(this.routePlannerForm.controls).forEach((ctrl) => {
          if (ctrl !== 'line') {
            if (!!lineFullData?.data) {
              this.routePlannerForm.controls[ctrl].enable();
            } else {
              this.routePlannerForm.controls[ctrl].disable();
            }
          }
        });

        setTimeout(() => {
          this.fetchedRouteData$.next(lineFullData?.data.route);
        });
      })
    );
  }

  override onTabLeave() {
    this.isAutofilling = false;
    this.routePlannerForm.reset(this.initialSearchLineFormValues)
  }

  override autofillQueryParams() {
    const queryParams = this.queryParamsService.currentParams;
    const hasInitializedRoute = !isNaN(parseInt(queryParams['routeId']));
    const hasInitializedBoardingStation = !isNaN(
      parseInt(queryParams['boardingStation'])
    );
    const hasInitializedDropingStation = !isNaN(
      parseInt(queryParams['dropingStation'])
    );
    // Prevent multiple initializations
    if (this.isAutofilling) {
      return;
    }

    if (hasInitializedRoute) {
      this.isAutofilling = true;
      this.toogleLoader.emit(true)
      const lineId = parseInt(queryParams['routeId']);
      const oppositeDirectionId = !isNaN(
        parseInt(queryParams['oppositeRouteId'])
      )
        ? parseInt(queryParams['oppositeRouteId'])
        : null;

      this.routePlannerForm.reset(null, { emitEvent: false });
      this.afterRouteStopsFetched(
        this.scheduleService.getRouteStops(lineId, oppositeDirectionId),
        false // Always set to false to prevent automatic initialization of stops
      )
        .pipe(
          switchMap((line) => {
            if (!!line?.data?.route) {
              this.routePlannerForm.patchValue(
                { line: line.data.route },
                { emitEvent: false }
              );

              return of(line.data.route);
            }

            return of(null);
          })
        )
        .subscribe({
          next: (line) => {
            if (!!line) {
              if (!line.stops || line.stops.length === 0) {
                this.modalService.openRouteNotActiveModal(lineId);
                this.isLineActive = false;
                this.toogleLoader.emit(false);
                return;
              }

              this.isLineActive = true
              const language = this.languageService.getSelectedLanguage();
              // Set stops options without automatically initializing first/last stops
              this.stops$ = of(
                (line?.stops ?? []).map((stop) => ({
                  label: stop.name[language.symbol] || stop.name.he || '',
                  value: stop,
                }))
              );

              // Handle boarding station from query params
              if (hasInitializedBoardingStation) {
                const stopcode = parseInt(queryParams['boardingStation']);
                const stop = line.stops?.find(
                  (routeStop) => routeStop.stopcode === stopcode
                );

                if (stop) {

                  this.routePlannerForm.patchValue(
                    { boardingStation: stop },
                    { emitEvent: false }
                  );
                } else {
                  console.warn(
                    'Boarding station not found in route stops:',
                    stopcode
                  );
                }
              } else {
                // If no boarding station in URL, set first stop
                if (line.stops && line.stops.length > 0) {
                  this.routePlannerForm.patchValue(
                    { boardingStation: line.stops[0] },
                    { emitEvent: false }
                  );
                }
              }

              // Handle dropping station from query params
              if (hasInitializedDropingStation) {
                const stopcode = parseInt(queryParams['dropingStation']);
                const stop = line.stops?.find(
                  (routeStop) => routeStop.stopcode === stopcode
                );

                if (stop) {

                  this.routePlannerForm.patchValue(
                    { dropingStation: stop },
                    { emitEvent: false }
                  );
                } else {
                  console.warn(
                    'Dropping station not found in route stops:',
                    stopcode
                  );
                }
              } else {
                // If no dropping station in URL, set last stop
                if (line.stops && line.stops.length > 0) {
                  this.routePlannerForm.patchValue(
                    { dropingStation: line.stops[line.stops.length - 1] },
                    { emitEvent: false }
                  );
                }
              }

              // Initialize boarding and droping stops
              this.boardingStops$ = this.stops$;
              this.dropingStops$ = this.stops$;
              
              // Reinitialize filtered observables
              this.initializeStationFiltering();

              // Update filtered options for boarding and dropping stations based on selected values
              if (this.routePlannerForm.controls['boardingStation'].value) {
                const boardingStop =
                  this.routePlannerForm.controls['boardingStation'].value;
                this.dropingStops$ = this.stops$.pipe(
                  map((stops) =>
                    stops.filter(
                      (stop) =>
                        stop.value.stopSequence > boardingStop.stopSequence &&
                        stop.value.stopSequence != 0
                    )
                  )
                );
                // Reinitialize filtered droping stops
                this.initializeDropingStationFiltering();
              }

              if (this.routePlannerForm.controls['dropingStation'].value) {
                const dropingStop =
                  this.routePlannerForm.controls['dropingStation'].value;
                this.boardingStops$ = this.stops$.pipe(
                  map((stops) =>
                    stops.filter(
                      (stop) =>
                        stop.value.stopSequence < dropingStop.stopSequence &&
                        stop.value.stopSequence != 0
                    )
                  )
                );
                // Reinitialize filtered boarding stops
                this.initializeBoardingStationFiltering();
              }

              if (this.routePlannerForm.valid && !this.isSubmittingForm) {
                setTimeout(() => this.submitRoutePlannerForm(), 500);
              }
            } else {
              this.modalService.openRouteNotActiveModal(lineId);
              this.isLineActive = false
            }
            this.isAutofilling = false;
            this.toogleLoader.emit(false)
          },
          error: () => {
            this.isAutofilling = false;
            this.toogleLoader.emit(false)
          }
        });
    }
  }

  private setFormOptions(
    route: RouteStops,
    oppositeRoute: RouteStops,
    initalizeCtrls?: boolean
  ) {
    this.setDirectionsOptions(route, oppositeRoute);
    this.setStopsOptions(route, initalizeCtrls);
  }

  private setDirectionsOptions(route: RouteStops, oppositeRoute: RouteStops) {

    const language = this.languageService.getSelectedLanguage();
    const tripHeadSign = route.tripHeadSign[language.symbol] || route.tripHeadSign.he || route.stops[route.stops.length - 1]?.name[language.symbol] || route.stops[route.stops.length - 1]?.name.he || route.routeLongName
    const oppositeTripHeadSign = oppositeRoute?.tripHeadSign[language.symbol] || oppositeRoute?.tripHeadSign.he  || oppositeRoute?.stops[oppositeRoute.stops.length - 1]?.name[language.symbol] || oppositeRoute?.stops[oppositeRoute.stops.length - 1]?.name.he || oppositeRoute?.routeLongName || ""
    const options = [
      {
        label: `${route.stops[0]?.name[language.symbol] || route.stops[0]?.name.he || ''} <-> ${tripHeadSign}`,
        value: route,
      },
    ];

    if (oppositeRoute && oppositeRoute.stops?.length) {
      options.push({
          label: `${oppositeRoute.stops[0]?.name[language.symbol] || oppositeRoute.stops[0]?.name.he || ''} <-> ${oppositeTripHeadSign}`,
        value: oppositeRoute,
      });
    }

    this.directionsOpts$ = of(options);

    this.routePlannerForm.controls['direction'].setValue(route, {
      emitEvent: false,
    });
  }

  private setStopsOptions(route: RouteStops, initializeCtrls?: boolean) {
    const language = this.languageService.getSelectedLanguage();
    this.stops$ = of(
      (route?.stops ?? []).map((stop) => ({ label: stop.name[language.symbol] || stop.name.he || '', value: stop }))
    );
    this.boardingStops$ = this.stops$.pipe(
      map((stops) => stops.filter((stop) => stop.value.stopSequence !== 0 && !stop.value.isPickup))
    );
    this.dropingStops$ = this.stops$.pipe(
      map((stops) => stops.filter((stop) => stop.value.stopSequence !== 0 && !stop.value.isDropoff))
    );
    
    // Reinitialize filtered observables when stops change
    this.initializeStationFiltering();
    
    setTimeout(() => {
      if (!!route.stops.length && !!initializeCtrls) {
        const firstBoardingStop = route.stops.find((s) => s.stopSequence !== 0 && !s.isPickup);
        const lastDropingStop = [...route.stops].reverse().find((s) => s.stopSequence !== 0 && !s.isDropoff);

        if (firstBoardingStop) {
          this.routePlannerForm.controls['boardingStation'].setValue(
            firstBoardingStop,
            { emitEvent: initializeCtrls }
          );
        }
        if (!this.routePlannerForm.controls['dropingStation'].value && lastDropingStop) {
          this.routePlannerForm.controls['dropingStation'].setValue(
            lastDropingStop,
            { emitEvent: initializeCtrls }
          );
        }
      }
    });
  }

  override openAutocomplete(
    lineFormControl: FormControl<RouteStops>,
    title: string,
    queryParam: string
  ) {
    this.routePlanningService._componentOverlaySub.next({
      componentType: LineAutoCompleteComponent,
      data: {
        title: title,
        queryParam: queryParam,
        line: lineFormControl.value,
        saveResultToStorage: true,
        closeCallbackFn: (route: RouteStops) => {
          if (!!route) {
            lineFormControl.setValue(route);

            if (!!queryParam) {
              const queryParams: any = {
                [queryParam]: route.routeName,
                routeId: route.routeId,
              };

              // Only add oppositeRouteId if it exists
              if (route.oppositeDirectionId) {
                queryParams.oppositeRouteId = route.oppositeDirectionId;
              }

              this.queryParamsService.setQueryParams(queryParams);
            }
          }
        },
      },
    });
  }

  public override submitRoutePlannerForm() {
    if (this.isSubmittingForm) {

      return;
    }
    if (!!this.routePlannerForm.valid || this.isPickedFromFavorite
    ) {

      
      this.isPickedFromFavorite = false
      const formValues = this.routePlannerForm.value as SearchLineForm;

      this.ensureOppositeRouteId();

      this.isSubmittingForm = true;

      this.toogleLoader.emit(true);
      this.scheduleService.getRouteFullData(formValues.line.routeId).subscribe({
        next: (res) => {
          if (!!res.data) {

            this.toogleLoader.emit(false);

            if (formValues.line && formValues.line.oppositeDirectionId) {
              this.queryParamsService.setQueryParam(
                'oppositeRouteId',
                formValues.line.oppositeDirectionId
              );
            }

            if(!formValues.boardingStation) {
              formValues.boardingStation = res.data.stops[0]
            }
            if(!formValues.dropingStation) {
              formValues.dropingStation = res.data.stops[res.data.stops.length - 1]
            }
            
            this.openLineResultsContainer(res.data, formValues);
            this.plannerSurveyOrchestrator.scheduleSurveyAfterSearch({
              plannerScenario: 'line',
              routeId: formValues.line?.routeId ?? res.data?.routeId,
            });
          }
          this.isSubmittingForm = false;
        },
        error: (err) => {
          this.isSubmittingForm = false;
          this.toogleLoader.emit(false);
          console.error('Error submitting form:', err);
        },
        complete: () => {
          // Ensure isSubmittingForm is reset even if the request completes without entering next/error handlers
          this.isSubmittingForm = false;
        },
      });
    }
  }

  private openLineResultsContainer(line: Route, formValues: SearchLineForm) {
    this.routePlanningService._componentOverlaySub.next({
      componentType: SearchLineResultsContainerComponent,
      data: {
        line: line,
        formValues: formValues,
        closeCallbackFn: (isLanguageDirectionChanged: boolean) => {
          if(isLanguageDirectionChanged) {
            this.openLineResultsContainer(line, formValues);
          }
        },
      },
    });
  }

  private ensureOppositeRouteId() {
    const queryParams = this.queryParamsService.currentParams;
    const routeId = queryParams['routeId'];
    const oppositeRouteId = queryParams['oppositeRouteId'];

    if (
      routeId &&
      !oppositeRouteId &&
      this.routePlannerForm.controls['line'].value
    ) {
      this.queryParamsService.setQueryParam(
        'oppositeRouteId',
        this.routePlannerForm.controls['line'].value.oppositeDirectionId
      );
    }
  }

  handleFavoriteLineClick(favoriteLine: FavoriteLine) {
    this.routePlannerForm.patchValue({ line: favoriteLine });

    if (favoriteLine) {
      this.isPickedFromFavorite = true
      if (favoriteLine.oppositeDirectionId) {
        this.queryParamsService.setQueryParams({
          routeId: favoriteLine.routeId,
          oppositeRouteId: favoriteLine.oppositeDirectionId,
        });
      }
    }
  }

  openAgencyContact(isForOrderSeat: boolean, agencyId: number) {
    this.modalService.openAgencyContactInfoModal(agencyId, isForOrderSeat)
  }

  getStopName(stop: Stop) {
    const language = this.languageService.getSelectedLanguage();
    return stop.name[language.symbol] || stop.name.he || '';
  }
}
